import AppContext from '@/types/context'
import { AreaItem } from '@/types/cms/AreaItem'
import Partials from '@/elements/Partials'
import React from 'react'
import { clsx } from 'clsx'
import styles from './GridHighlight.module.scss'

const GridHighlight = ({ item, context }: { item: AreaItem; context: AppContext }) => {
  return (
    <div
      className={clsx(styles.container, styles[`container--${item.model?.fields?.backgroundColor}`])}
      data-cy={`grid-highlight-${item.model?.fields?.backgroundColor}`}
    >
      {item.children.map((child, index) => {
        return <Partials key={index} context={context} item={child as any} />
      })}
    </div>
  )
}

export default GridHighlight
